import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'CONCATENATE',
  category: FunctionCategory.TEXT,
  description:
    'Appends strings across each row of the given columns. Single strings are treated as columns containing only that string.',
  shortDescription: 'Appends strings to one another',
  params: [
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string.',
    },
  ],
  repeatableLastParamType: ArgType.text,
  repeatableLastParamDescription: 'Additional columns or strings.',
} satisfies AnalysisFunction;
